import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightbulb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "lightbulb_2",
		d: "M10 17.9808C9.57905 17.9808 9.21606 17.8349 8.91106 17.5433C8.60606 17.2516 8.44023 16.8953 8.41356 16.4743H11.5865C11.5598 16.8953 11.394 17.2516 11.089 17.5433C10.784 17.8349 10.421 17.9808 10 17.9808ZM6.87502 15.3203V14.0703H13.125V15.3203H6.87502ZM7.00315 12.9166C6.13037 12.3738 5.43946 11.6646 4.93044 10.7891C4.42127 9.91367 4.16669 8.95617 4.16669 7.91659C4.16669 6.2927 4.73294 4.9145 5.86544 3.782C6.99794 2.6495 8.37613 2.08325 10 2.08325C11.6239 2.08325 13.0021 2.6495 14.1346 3.782C15.2671 4.9145 15.8334 6.2927 15.8334 7.91659C15.8334 8.95617 15.5788 9.91367 15.0696 10.7891C14.5606 11.6646 13.8697 12.3738 12.9969 12.9166H7.00315ZM7.37502 11.6666H12.625C13.25 11.2221 13.7327 10.6735 14.0729 10.0208C14.4132 9.36797 14.5834 8.66659 14.5834 7.91659C14.5834 6.63881 14.1389 5.55547 13.25 4.66659C12.3611 3.7777 11.2778 3.33325 10 3.33325C8.72224 3.33325 7.63891 3.7777 6.75002 4.66659C5.86113 5.55547 5.41669 6.63881 5.41669 7.91659C5.41669 8.66659 5.58683 9.36797 5.9271 10.0208C6.26738 10.6735 6.75002 11.2221 7.37502 11.6666Z",
		fill: "currentColor"
	})
});
export default SvgLightbulb;
